var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    {
      attrs: { trigger: "click" },
      scopedSlots: _vm._u([
        {
          key: "dropdown",
          fn: function() {
            return [
              _c(
                "el-dropdown-menu",
                _vm._l(_vm.actions, function(action, index) {
                  return _c(
                    "el-dropdown-item",
                    {
                      key: index,
                      class: !_vm.hasAccess(action.permission, _vm.permissions)
                        ? "link-disabled"
                        : "",
                      attrs: {
                        disabled: !_vm.hasAccess(
                          action.permission,
                          _vm.permissions
                        )
                      }
                    },
                    [
                      action.childrens && action.childrens.length > 0
                        ? _c(
                            "el-dropdown",
                            {
                              staticClass: "wp-10",
                              attrs: { placement: "right-start" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "dropdown",
                                    fn: function() {
                                      return [
                                        _c(
                                          "el-dropdown-menu",
                                          _vm._l(action.childrens, function(
                                            children,
                                            childIndex
                                          ) {
                                            return _c(
                                              "el-dropdown-item",
                                              { key: childIndex },
                                              [
                                                children.type == "vuejs"
                                                  ? _c(
                                                      "a",
                                                      {
                                                        class: !_vm.hasAccess(
                                                          children.permission,
                                                          _vm.permissions
                                                        )
                                                          ? "link-disabled"
                                                          : "",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.$emit(
                                                              "clicked",
                                                              children.value
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                    " +
                                                            _vm._s(
                                                              children.label
                                                            ) +
                                                            "\n                                "
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "a",
                                                      {
                                                        class: !_vm.hasAccess(
                                                          children.permission,
                                                          _vm.permissions
                                                        )
                                                          ? "link-disabled"
                                                          : "",
                                                        attrs: {
                                                          href: children.value
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                    " +
                                                            _vm._s(
                                                              children.label
                                                            ) +
                                                            "\n                                "
                                                        )
                                                      ]
                                                    )
                                              ]
                                            )
                                          }),
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _c(
                                "el-dropdown-item",
                                { staticClass: "p-0 gray-100" },
                                [_vm._v(_vm._s(action.label))]
                              )
                            ],
                            1
                          )
                        : _c("div", [
                            action.type == "vuejs"
                              ? _c(
                                  "a",
                                  {
                                    class: !_vm.hasAccess(
                                      action.permission,
                                      _vm.permissions
                                    )
                                      ? "link-disabled"
                                      : "",
                                    on: {
                                      click: function($event) {
                                        return _vm.$emit(
                                          "clicked",
                                          action.value
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(action.label) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              : _c(
                                  "a",
                                  {
                                    class: !_vm.hasAccess(
                                      action.permission,
                                      _vm.permissions
                                    )
                                      ? "link-disabled"
                                      : "",
                                    attrs: { href: action.value }
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(action.label) +
                                        "\n                    "
                                    )
                                  ]
                                )
                          ])
                    ],
                    1
                  )
                }),
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("a", { staticClass: "btn-icon", attrs: { href: "javascript:;" } }, [
        _c("i", { staticClass: "icon-burger" })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }